// extracted by css-extract-rspack-plugin
export default {"commentBody":"PendingCommentPreview-module__commentBody__d_tAU"};